import { Card, CardContent } from "@shared/ui/card";
import { ArrowDown, ArrowUp } from "lucide-react";

interface KpiStatsCardProps {
  label: string;
  value: string | number;
  subtitle?: string;
  trend?: {
    value: number;
    direction: "up" | "down";
    label: string;
  };
  className?: string;
}

export const KpiStatsCard = ({
  label,
  value,
  subtitle,
  trend,
  className = "",
}: KpiStatsCardProps) => {
  return (
    <Card className={className}>
      <CardContent className="p-4">
        <div className="space-y-2">
          <p className="text-xs font-medium text-gray-500 uppercase">{label}</p>
          <p className="text-2xl font-bold text-gray-900">{value}</p>
          {trend && (
            <div className="flex items-center gap-1">
              {trend.direction === "up" ? (
                <ArrowUp className="h-3 w-3 text-green-600" />
              ) : (
                <ArrowDown className="h-3 w-3 text-red-600" />
              )}
              <span
                className={`text-xs font-medium ${
                  trend.direction === "up" ? "text-green-600" : "text-red-600"
                }`}
              >
                {trend.value}%
              </span>
              <span className="text-xs text-gray-500">{trend.label}</span>
            </div>
          )}
          {subtitle && !trend && (
            <p className="text-xs text-gray-500">{subtitle}</p>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
